import { ChronicDisease } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { ChronicDiseaseDetailsModal } from './ChronicDiseaseDetailsModal';

type ChronicDiseaseDetailsModalOpenerRenderer = (renderProps: { openModal: VoidFunction }) => JSX.Element;

type ChronicDiseaseDetailsModalOpenerProps = {
   readonly chronicDisease: ChronicDisease;
   readonly children: ChronicDiseaseDetailsModalOpenerRenderer;
   readonly onMedicalDataAccessAuthorizationUpdate?: VoidFunction;
};

export const ChronicDiseaseDetailsModalOpener = (props: ChronicDiseaseDetailsModalOpenerProps): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <ChronicDiseaseDetailsModal
               chronicDisease={props.chronicDisease}
               onClose={closeModal}
               onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
            />
         ) : null}
      </>
   );
};
